import { PoliciesTable } from '@salescore/client-feature-setting'
import { createFileRoute } from '@tanstack/react-router'

const Page = () => <PoliciesTable />

export const Route = createFileRoute('/o/$organizationId/v2/settings/policies')({
  component: Page,
})
